/* src/app/components/excelqueandans/excel-upload/excel-upload.component.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
}
:host,
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
}
.excel-workspace {
  min-height: 100vh;
  padding: 0;
  color: #172033;
}
.workspace-header {
  min-height: 76px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.header-left {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-content {
  min-width: 0;
}
.title-line {
  display: flex;
  align-items: center;
  gap: 10px;
}
.title-line h1 {
  margin: 0;
  color: #101828;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.25px;
}
.header-content p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}
.excel-logo {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #ecfdf3;
  color: #16a34a;
  font-size: 19px;
}
.history-btn {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 14px;
  border: 1px solid #e4e7ec;
  border-radius: 7px;
  background: #ffffff;
  color: #475467;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: 180ms ease;
}
.history-btn:hover,
.history-btn.active {
  border-color: #253b80;
  background: #253b80;
  color: #fff;
}
.progress-navigation {
  min-height: 70px;
  padding: 0 26px;
  display: flex;
  align-items: center;
}
.progress-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 155px;
  opacity: 0.45;
  transition: 180ms ease;
}
.progress-item.active {
  opacity: 1;
}
.progress-item.active .progress-number {
  border-color: #253b80;
  background: #253b80;
  color: #fff;
}
.progress-item.active strong {
  color: #172033;
}
.progress-number {
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d0d5dd;
  border-radius: 50%;
  background: #fff;
  color: #98a2b3;
  font-size: 11px;
  font-weight: 700;
}
.progress-item strong,
.progress-item span {
  display: block;
}
.progress-item strong {
  color: #667085;
  font-size: 14px;
  font-weight: 650;
}
.progress-item span {
  margin-top: 3px;
  color: #98a2b3;
  font-size: 11px;
}
.progress-connector {
  height: 1px;
  flex: 1;
  margin: 0 16px;
  background: #e4e7ec;
}
.workspace-content {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 26px 28px 42px;
  box-sizing: border-box;
}
.import-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.65fr);
  background: #ffffff;
  border-top: 1px solid #e4e7ec;
  border-bottom: 1px solid #e4e7ec;
}
.import-panel,
.collection-panel {
  min-width: 0;
  padding: 28px;
}
.import-panel {
  border-right: 1px solid #e4e7ec;
}
.collection-panel {
  background: #fcfcfd;
}
.panel-heading {
  display: flex;
  align-items: flex-start;
  gap: 13px;
}
.heading-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 17px;
}
.heading-icon.excel {
  background: #ecfdf3;
  color: #16a34a;
}
.heading-icon.purple {
  background: #eef2ff;
  color: #253b80;
}
.panel-heading h2 {
  margin: 0;
  color: #101828;
  font-size: 18px;
  line-height: 1.4;
  font-weight: 700;
}
.panel-heading p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 14px;
  line-height: 1.55;
}
.drop-zone {
  min-height: 220px;
  margin-top: 22px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #fcfdff;
  text-align: center;
  cursor: pointer;
  transition: 180ms ease;
}
.drop-zone:hover {
  border-color: #253b80;
  background: #eef2ff;
}
.drop-icon {
  position: relative;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #ecfdf3;
  color: #16a34a;
  font-size: 24px;
}
.drop-plus {
  position: absolute;
  right: -5px;
  bottom: -5px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #253b80;
  color: #fff;
  font-size: 10px;
}
.drop-zone h3 {
  margin: 15px 0 5px;
  color: #172033;
  font-size: 16px;
  font-weight: 650;
}
.drop-zone p {
  margin: 0;
  color: #667085;
  font-size: 14px;
  line-height: 1.6;
}
.drop-zone p strong {
  color: #253b80;
}
.file-rules {
  margin-top: 14px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
}
.file-rules span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #98a2b3;
  font-size: 11px;
}
.file-rules span i {
  color: #16a34a;
}
.collection-form {
  margin-top: 23px;
}
.collection-form > label {
  display: block;
  margin-bottom: 8px;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
}
.class-dropdown {
  width: 100%;
}
.helper-message {
  margin-top: 10px;
  display: flex;
  gap: 7px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.55;
}
.helper-message i {
  margin-top: 3px;
  color: #253b80;
}
.selected-collection {
  margin-top: 18px;
  padding: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #bbf7d0;
  background: #ecfdf3;
}
.collection-folder {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #dcfce7;
  color: #16a34a;
}
.selected-collection span {
  display: block;
  color: #98a2b3;
  font-size: 11px;
}
.selected-collection strong {
  display: block;
  margin-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #344054;
  font-size: 14px;
}
.selected-collection > i {
  margin-left: auto;
  color: #16a34a;
}
.workspace-panel {
  margin-top: 28px;
  background: #ffffff;
  border-top: 1px solid #e4e7ec;
  border-bottom: 1px solid #e4e7ec;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  box-shadow: none;
  padding: 20px;
}
.workspace-panel-header {
  padding: 22px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.section-label {
  display: block;
  margin-bottom: 5px;
  color: #253b80;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.8px;
}
.workspace-panel-header h2 {
  margin: 0;
  color: #172033;
  font-size: 20px;
  font-weight: 700;
}
.workspace-panel-header p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 14px;
}
.select-all {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.select-all input {
  position: absolute;
  opacity: 0;
}
.select-all .checkbox {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #98a2b3;
  border-radius: 4px;
  background: #fff;
  transition: all 0.2s ease;
}
.select-all .checkbox::after {
  content: "";
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) scale(0);
  transition: transform 0.15s ease;
}
.select-all input:checked + .checkbox {
  border-color: #253b80;
  background: #253b80;
}
.select-all input:checked + .checkbox::after {
  transform: rotate(45deg) scale(1);
}
.select-all input:focus-visible + .checkbox {
  outline: 2px solid #253b80;
  outline-offset: 2px;
}
.select-all strong {
  color: #475467;
  font-size: 12px;
  font-weight: 600;
}
.document-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  width: 100%;
  box-sizing: border-box;
}
.document-tile {
  min-width: 0;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease;
}
.document-tile:hover {
  background: #fafcff;
  border-color: #cbd5e1;
}
.document-tile.selected {
  background: #eef2ff;
  border-color: #253b80;
  box-shadow: inset 3px 0 0 #253b80;
}
.tile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.document-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.document-checkbox input {
  position: absolute;
  opacity: 0;
}
.document-checkbox span {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #98a2b3;
  border-radius: 4px;
  background: #fff;
  transition: all 0.2s ease;
}
.document-checkbox span::after {
  content: "";
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) scale(0);
  transition: transform 0.15s ease;
}
.document-checkbox input:checked + span {
  border-color: #253b80;
  background: #253b80;
}
.document-checkbox input:checked + span::after {
  transform: rotate(45deg) scale(1);
}
.document-checkbox input:focus-visible + span {
  outline: 2px solid #253b80;
  outline-offset: 2px;
}
.document-format {
  padding: 4px 7px;
  border-radius: 4px;
  background: #f2f4f7;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}
.document-image {
  width: 44px;
  height: 44px;
  margin: 15px 0 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff5f5;
}
.document-image img {
  width: 26px;
  height: 26px;
  object-fit: contain;
}
.document-title h3 {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #172033;
  font-size: 15px;
  font-weight: 650;
}
.document-owner {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #98a2b3;
  font-size: 12px;
}
.document-bottom {
  margin-top: 14px;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #f0f2f5;
  color: #98a2b3;
  font-size: 11px;
}
.document-available {
  color: #16a34a;
  font-weight: 650;
}
.mapping-header .mapping-tip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #667085;
  font-size: 12px;
}
.mapping-header .mapping-tip i {
  color: #253b80;
}
.mapping-table {
  width: 100%;
  overflow-x: auto;
}
.mapping-table-head,
.mapping-table-row {
  display: grid;
  grid-template-columns: minmax(180px, 1.1fr) minmax(170px, 1fr) minmax(170px, 1fr) 45px;
  gap: 14px;
  align-items: center;
}
.mapping-table-head {
  padding: 12px 0 9px;
  color: #98a2b3;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.mapping-table-row {
  padding: 14px 0;
  border-top: 1px solid #e4e7ec;
}
.mapping-table-row:hover {
  background: #fcfdff;
}
.sheet-name {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.sheet-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #ecfdf3;
  color: #16a34a;
}
.sheet-name span {
  display: block;
  color: #98a2b3;
  font-size: 11px;
}
.sheet-name strong {
  display: block;
  margin-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #172033;
  font-size: 14px;
}
.mapping-select label {
  display: block;
  margin-bottom: 6px;
  color: #475467;
  font-size: 12px;
  font-weight: 600;
}
.mapping-select label em {
  color: #dc2626;
  font-style: normal;
}
.mapping-select > div {
  position: relative;
}
.mapping-select select {
  width: 100%;
  height: 40px;
  appearance: none;
  padding: 0 32px 0 11px;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  outline: none;
  background: #fff;
  color: #344054;
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: 180ms ease;
}
.mapping-select select:hover {
  border-color: #98a2b3;
}
.mapping-select select:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.08);
}
.mapping-select > div > i {
  position: absolute;
  right: 10px;
  top: 50%;
  color: #98a2b3;
  font-size: 11px;
  pointer-events: none;
  transform: translateY(-50%);
}
.delete-sheet {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #98a2b3;
  cursor: pointer;
  transition: 180ms ease;
}
.delete-sheet:hover {
  background: #fef2f2;
  color: #dc2626;
}
.panel-footer {
  padding: 17px 0;
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  border-top: 1px solid #e4e7ec;
}
.primary-action,
.secondary-action,
.download-action {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 15px;
  border-radius: 7px;
  font-size: 14px;
  font-weight: 650;
  cursor: pointer;
}
.primary-action {
  border: 1px solid #253b80;
  background: #253b80;
  color: #fff;
}
.primary-action:hover {
  background: #1e326d;
}
.secondary-action {
  border: 1px solid #d0d5dd;
  background: #fff;
  color: #475467;
}
.secondary-action:hover {
  background: #f9fafb;
}
.download-action {
  border: 1px solid #16a34a;
  background: #16a34a;
  color: #fff;
}
.download-action:hover {
  background: #15803d;
}
.results-list {
  padding: 0;
}
.sheet-block {
  border-bottom: 1px solid #e4e7ec;
}
.sheet-block:last-child {
  border-bottom: 0;
}
.sheet-block-header {
  width: 100%;
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
}
.sheet-block-header:hover {
  background: #fafbfc;
}
.sheet-block-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.sheet-result-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #ecfdf3;
  color: #16a34a;
}
.sheet-block-title span {
  display: block;
  color: #98a2b3;
  font-size: 11px;
}
.sheet-block-title strong {
  display: block;
  margin-top: 3px;
  color: #172033;
  font-size: 14px;
}
.sheet-chevron {
  color: #98a2b3;
  font-size: 12px;
}
.qa-list {
  padding: 0 0 18px 45px;
}
.qa-card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 30px minmax(0, 1fr);
  align-items: center;
  border-top: 1px solid #f0f2f5;
}
.qa-card:not(:last-child) {
  margin-bottom: 6px;
}
.qa-question,
.qa-answer {
  padding: 14px 16px;
  background: #fafbfc;
}
.qa-question p,
.qa-answer p {
  margin: 8px 0 0;
  color: #344054;
  font-size: 14px;
  line-height: 1.65;
  overflow-wrap: anywhere;
}
.qa-question {
  border-left: 2px solid #253b80;
}
.qa-answer {
  border-left: 2px solid #16a34a;
}
.qa-label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #667085;
  font-size: 11px;
  font-weight: 750;
  text-transform: uppercase;
}
.qa-question .qa-label i {
  color: #253b80;
}
.qa-answer .qa-label i {
  color: #16a34a;
}
.qa-divider {
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  border-radius: 50%;
  background: #f2f4f7;
  color: #98a2b3;
  font-size: 11px;
}
.loading-state,
.empty-state {
  padding: 65px 20px;
  text-align: center;
}
.loading-ring {
  width: 30px;
  height: 30px;
  margin: 0 auto 13px;
  border: 3px solid #e4e7ec;
  border-top-color: #253b80;
  border-radius: 50%;
  animation: excel-spin 0.8s linear infinite;
}
@keyframes excel-spin {
  to {
    transform: rotate(360deg);
  }
}
.empty-symbol {
  width: 52px;
  height: 52px;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f2f4f7;
  color: #98a2b3;
  font-size: 20px;
}
.loading-state h3,
.empty-state h3 {
  margin: 0;
  color: #172033;
  font-size: 16px;
}
.loading-state p,
.empty-state p {
  margin: 6px 0 0;
  color: #667085;
  font-size: 12px;
}
.history-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(16, 24, 40, 0.25);
}
.history-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2001;
  width: 410px;
  max-width: 92vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-left: 1px solid #e4e7ec;
  box-shadow: -10px 0 35px rgba(16, 24, 40, 0.12);
  transform: translateX(100%);
  transition: transform 220ms ease;
}
.history-drawer.open {
  transform: translateX(0);
}
.history-top {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e4e7ec;
}
.history-title {
  display: flex;
  align-items: center;
  gap: 11px;
}
.history-title-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #eef2ff;
  color: #253b80;
}
.history-title h2 {
  margin: 0;
  color: #172033;
  font-size: 18px;
}
.history-title p {
  margin: 4px 0 0;
  color: #98a2b3;
  font-size: 12px;
}
.history-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: #f2f4f7;
  color: #475467;
  cursor: pointer;
}
.history-search {
  position: relative;
  margin: 16px 20px;
}
.history-search > i {
  position: absolute;
  left: 12px;
  top: 50%;
  color: #98a2b3;
  transform: translateY(-50%);
}
.history-search input {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 36px;
  border: 1px solid #d0d5dd;
  border-radius: 7px;
  outline: none;
  font-size: 14px;
}
.history-search input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07);
}
.history-search button {
  position: absolute;
  right: 5px;
  top: 50%;
  width: 27px;
  height: 27px;
  border: 0;
  background: transparent;
  color: #98a2b3;
  transform: translateY(-50%);
  cursor: pointer;
}
.history-content {
  flex: 1;
  overflow-y: auto;
}
.history-row {
  margin: 0 10px;
  padding: 6px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f2f5;
}
.history-row:hover {
  background: #fafbfc;
}
.history-file {
  min-width: 0;
  flex: 1;
  padding: 7px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
.history-excel-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #ecfdf3;
  color: #16a34a;
}
.history-file-text {
  min-width: 0;
}
.history-file-text strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #172033;
  font-size: 12px;
}
.history-file-text span {
  display: block;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 11px;
}
.history-delete {
  width: 31px;
  height: 31px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #98a2b3;
  cursor: pointer;
}
.history-delete:hover {
  background: #fef2f2;
  color: #dc2626;
}
.processing-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
.processing-card {
  width: 300px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #e4e7ec;
  background: #fff;
  text-align: center;
  box-shadow: 0 15px 40px rgba(16, 24, 40, 0.12);
}
.processing-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #ecfdf3;
  color: #16a34a;
}
.processing-loader {
  width: 28px;
  height: 28px;
  margin: 15px 0;
  border: 3px solid #e4e7ec;
  border-top-color: #253b80;
  border-radius: 50%;
  animation: excel-spin 0.8s linear infinite;
}
.processing-card h3 {
  margin: 0;
  color: #172033;
  font-size: 16px;
}
.processing-card p {
  margin: 6px 0 0;
  color: #667085;
  font-size: 12px;
}
:host ::ng-deep .class-dropdown {
  width: 100%;
}
:host ::ng-deep .class-dropdown .p-dropdown {
  width: 100%;
  min-height: 42px;
  border: 1px solid #d0d5dd;
  border-radius: 7px;
  box-shadow: none;
}
:host ::ng-deep .class-dropdown .p-dropdown:not(.p-disabled).p-focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.07);
}
:host ::ng-deep .class-dropdown .p-dropdown-label {
  padding: 10px 12px;
  color: #344054;
  font-size: 14px;
}
:host ::ng-deep .class-dropdown .p-dropdown-item {
  padding: 10px 12px;
  color: #344054;
  font-size: 14px;
}
@media (max-width: 1100px) {
  .import-layout {
    grid-template-columns: 1fr;
  }
  .import-panel {
    border-right: 0;
    border-bottom: 1px solid #e4e7ec;
  }
}
@media (max-width: 850px) {
  .workspace-content {
    padding: 22px;
  }
  .progress-navigation {
    overflow-x: auto;
  }
  .progress-item {
    min-width: 135px;
  }
  .mapping-table {
    overflow-x: auto;
  }
  .mapping-table-head,
  .mapping-table-row {
    min-width: 700px;
  }
}
@media (max-width: 650px) {
  .workspace-header {
    min-height: 68px;
    padding: 0 16px;
  }
  .title-line h1 {
    font-size: 20px;
  }
  .header-content p {
    display: none;
  }
  .history-btn span {
    display: none;
  }
  .history-btn {
    width: 40px;
    padding: 0;
  }
  .progress-navigation {
    padding: 0 16px;
  }
  .progress-item > div:last-child {
    display: none;
  }
  .progress-item {
    min-width: auto;
  }
  .progress-number {
    width: 30px;
    height: 30px;
  }
  .progress-connector {
    min-width: 25px;
    margin: 0 8px;
  }
  .workspace-content {
    padding: 18px 15px 30px;
  }
  .import-panel,
  .collection-panel {
    padding: 20px;
  }
  .panel-heading h2 {
    font-size: 17px;
  }
  .panel-heading p {
    font-size: 13px;
  }
  .drop-zone {
    min-height: 200px;
    padding: 24px 15px;
  }
  .drop-zone h3 {
    font-size: 16px;
  }
  .drop-zone p {
    font-size: 14px;
  }
  .workspace-panel-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .workspace-panel-header h2 {
    font-size: 18px;
  }
  .document-layout {
    grid-template-columns: 1fr;
  }
  .qa-list {
    padding-left: 0;
  }
  .qa-card {
    grid-template-columns: 1fr;
  }
  .qa-divider {
    display: none;
  }
  .qa-answer {
    border-top: 1px solid #e4e7ec;
  }
  .qa-question p,
  .qa-answer p {
    font-size: 14px;
  }
  .panel-footer {
    flex-direction: column;
  }
  .panel-footer button {
    width: 100%;
  }
  .history-drawer {
    width: 100%;
    max-width: 100%;
  }
}
@media (max-width: 430px) {
  .workspace-content {
    padding: 12px;
  }
  .workspace-header {
    padding: 0 12px;
  }
  .title-line h1 {
    font-size: 19px;
  }
  .excel-logo {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
  }
  .drop-zone {
    min-height: 185px;
    padding: 22px 12px;
  }
  .file-rules {
    flex-direction: column;
    gap: 7px;
  }
  .import-panel,
  .collection-panel {
    padding: 17px;
  }
  .document-tile {
    padding: 16px;
  }
  .workspace-panel-header {
    padding: 18px 0;
  }
  .history-drawer {
    width: 100%;
    max-width: 100%;
  }
}
:host button:focus-visible,
:host [role=button]:focus-visible,
:host input:focus-visible,
:host select:focus-visible,
:host .drop-zone:focus-visible {
  outline: 2px solid #253b80;
  outline-offset: 3px;
}
@media (prefers-reduced-motion: reduce) {
  :host *,
  :host *::before,
  :host *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
/*# sourceMappingURL=excel-upload.component.css.map */
